/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-12 19:05:31
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-12 19:27:46
 */
const Log = (value) => {
  window.clickLog(`from=${value}`) ;
}

export {
  Log
}